import Vue           from 'vue'
import App           from './App.vue'
import axios         from 'axios'
import VueRouter     from 'vue-router'
import routers       from './router'
import helpers       from './helpers'
import constant      from './helpers/constant'
import VeeValidate   from 'vee-validate'
import env           from '../env'

import './lang/index'
/**
 * load framework7
 */
import 'framework7-icons'
import 'animate.css/animate.min.css'
import 'framework7/css/framework7.bundle.min.css'
import Framework7 from 'framework7/framework7.esm.bundle.js'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'
Framework7.use(Framework7Vue)

/**
 * config for axios
 */
axios.defaults.baseURL = env.api
axios.defaults.headers.common['lang'] = localStorage.getItem('vueml-lang') || env.defaultLang
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 403) {
        console.log(error)
        localStorage.removeItem('userLogin')
        window.location.href = '/login'
    }
    return Promise.reject(error);
});

/**
 * use necessary library
 */
Vue.use(VueRouter)
Vue.use(VeeValidate);
Vue.use({
    install () {
        Vue.helper   = helpers
        Vue.constant = constant
        Vue.prototype.$helper   = helpers
        Vue.prototype.$constant = constant
    }
})

/**
 * create new vue application
 */
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.prototype.$listener = new Vue()
new Vue({
    el: '#app',
    render: h => h(App),
    router: new VueRouter({
        routes: routers,
        mode: 'history',
    }),
})
